<form [formGroup]="formGroup">
  <div class="space-y-12">
    <div class="border-b border-gray-900/10 pb-6">
      <p class="mt-1 text-sm/6 text-gray-600">You can edit the NW Number here.</p>

      <div class="grid gap-6 mt-6">
        <div class="col-span-full">
          <app-text-area
            formControlName="shortDescription"
            [fieldConfigurationAddress]="'nwNumber.shortDescription'"
            [label]="'Short description'"
            [fieldIsRequired]="false"
            [displayChangeIndicator]="false"
            [reset$]="resetFieldTracking$"
            appTrackUnsavedField
          ></app-text-area>
        </div>

        <div class="col-span-full">
          <app-label-with-help for="projectId" class="primary-label" fieldConfigurationAddress="nwNumber.projectId"
            >Project</app-label-with-help
          >
          <div class="relative">
            <app-selection
              formControlName="projectId"
              [options]="projectOptions"
              appTrackUnsavedField
              [reset$]="resetFieldTracking$"
              (unsavedChanges)="hasProjectIdUnsavedChanges = $event"
              [unsavedChanges]="hasProjectIdUnsavedChanges"
            ></app-selection>
          </div>
        </div>

        <div class="col-span-full">
          <app-text-area
            formControlName="productLine"
            [fieldConfigurationAddress]="'nwNumber.productLine'"
            [label]="'Product line'"
            [fieldIsRequired]="false"
            [displayChangeIndicator]="false"
            [reset$]="resetFieldTracking$"
          ></app-text-area>
        </div>

        <div class="col-span-full">
          <app-text-area
            formControlName="internalNotes"
            [fieldConfigurationAddress]="'nwNumber.internalNotes'"
            [label]="'Internal notes'"
            [fieldIsRequired]="false"
            [displayChangeIndicator]="false"
            [reset$]="resetFieldTracking$"
          ></app-text-area>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-6 flex items-center justify-end gap-x-6">
    <button
      type="button"
      [disabled]="formGroup.invalid"
      (click)="updateNwNumber()"
      class="crud-btn-sidebar"
      appAgentAction
      agent="save-nw-number"
      businessObject="nwNumber"
      [businessId]="$safeNavigationMigration(nwNumber?.id)"
      action="save"
    >
      <app-floppy-icon></app-floppy-icon>
    </button>
  </div>
</form>
